module.exports = __webpack_public_path__ + "img/icon-file-download.ff7bfed7.svg";